// extracted by mini-css-extract-plugin
module.exports = {"center":"center_center__FhyIy"};